import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-wizard-step',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './wizard-step.component.html',
  styleUrl: './wizard-step.component.scss',
})
export class WizardStepComponent {
  public stepNumber = input.required<number>();
  public stepId = input.required<string>();
  public isActive = input.required<boolean>();

  constructor() {}
}
